<template>
  <el-container>
    <div class="image"
        v-if="imgType!='scroll'"
         :style="{
          background: 'url(' + imgSrc + ') no-repeat',
          backgroundPosition: 'center 20%',
          backgroundSize: '100%',
          cursor: 'pointer'}"
      @click="$router.push({path: path})">

    </div>
    <div class="image" v-if="imgType=='scroll'">
      <el-carousel :interval="3000" arrow="always">
        <el-carousel-item>
          <a href="http://www.ifopendata.cn/questionnaires/">
            <img :src="require('../../assets/images/banner/common_banner.jpg')" alt="">
          </a>
          
        </el-carousel-item>
        <el-carousel-item @click="$router.push({path: path})">
          <img :src="imgSrc" alt="">
        </el-carousel-item>
      </el-carousel>
      <div v-for="(item,index) in list" ::key="index" class="data_button" :style="{left:item.left}" @click="$router.push({path: item.path})">{{item.name}}</div>
    </div>
  </el-container>
</template>

<script>
    export default {
        name: 'CommonBanner',
        props: {
            imgSrc: {
                type: String,
                required: true
            },
            path: {
                type: String,
                required: true
            },
            imgType: {
                type: String,
                required: false,
                default: ''
            }
        },
        data() {
            return {
                list: [{
                    name: '数据库',
                    path: '/opendata',
                    left: '100px'
                }, {
                    name: '政策库',
                    path: '/policy',
                    left: '260px'
                }, {
                    name: '文献库',
                    path: '/paper',
                    left: '420px'
                }, {
                    name: '案例库',
                    path: '/case',
                    left: '580px'
                }]
            }
        }
    }
</script>
<style>
    .image .el-carousel__container {
        height: 384px;
    }
</style>
<style scoped>
    .image {
        height: 384px;
        width: 100%;
        position: relative;
    }
    
    .data_button {
        width: 150px;
        height: 40px;
        background: rgba(0, 0, 0, 0.6);
        position: absolute;
        bottom: 0;
        z-index: 10;
        color: #fff;
        font-size: 20px;
        text-align: center;
        line-height: 40px;
        font-weight: 500;
        cursor: pointer;
    }
    
    .image img {
        height: 384px;
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/pages/common/Banner.vue